/* eslint-disable no-empty-pattern */
import React, { useState, useContext, useEffect } from "react";
import Lottie from 'react-lottie';
import kudaSuccessAnimation from '../../assets/animations/success-dark.json'
import { StateContext } from "../../contextApi";
import { closeModalOnClick } from "../../util/util";

const DarkSuccessModal = () => {
    const [state, setState] = useState({
        isStopped: true,
    })

    const [{ darkSuccessModalPayload }, dispatch] = useContext(StateContext)

    const closeModal = async () => {
        dispatch({
            key: 'darkSuccessModal',
            type: "CHANGE_API_MODAL",
            value: false,
            newPayload:{
                action: 'closeModal'
            }
        });
    }


    const handleAnim = () => {
        setState({ isStopped: false })
    }

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        closeModalOnClick(closeModal);
        return () => {
            document.body.classList.remove("backdrop-init");
        }
    }, [])

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: kudaSuccessAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <React.Fragment>
            <div className="modal modal-sendMoney small-modal modal-backdrop kuda-success--modal fadeIn animated">
                <div className="modal-content fadeInUp animated">
                    <div className="kuda-modal--content">
                        <h4 className="modal-title  color-black text-center text-xbold margin-bottom--spacer">

                            {darkSuccessModalPayload?.message && darkSuccessModalPayload?.message !== "Done."
                                ? darkSuccessModalPayload?.message : "Success!"}

                        </h4>
                        <div className="kuda-modal-illustration">
                            <Lottie options={defaultOptions}
                                height={`100%`}
                                width={`100%`}
                                isStopped={state.isStopped}
                                eventListeners={
                                    [
                                        {
                                            eventName: 'DOMLoaded',
                                            callback: anim => handleAnim(anim),
                                        },
                                    ]
                                }
                            />
                        </div>
                        {darkSuccessModalPayload?.children}

                        <div className="flex justify-center mt-5">
                            <div
                                className={`dark-cta kuda-cta kuda-cta-md`}
                                onClick={darkSuccessModalPayload?.onActionClicked ? darkSuccessModalPayload?.onActionClicked : closeModal}
                            >
                                <span>{darkSuccessModalPayload?.btnText || "Okay"}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default DarkSuccessModal;